import React from 'react';
import { SEO } from 'src/components';

import { Layout } from 'src/components/page-skills';

export default (props: any) => (
  <>
    <SEO title='Skills' pathname={props.path} />
    <Layout />
  </>
);
